import { Output } from "valibot";

import MessageAvatar from "components/MessageBubble/MessageAvatar";
import { BotInfoSchema } from "components/SonicBot/schemas";
import { IntegrationHandler } from "shared/integrations";
import { IntegrationType } from "shared/integrations/configs";
import { AppConfiguration } from "shared/types";

type Props = {
  botInfo: Output<typeof BotInfoSchema>;
  integration: IntegrationHandler;
  onIntegrationClick: (integration: IntegrationHandler) => Promise<void>;
  config: AppConfiguration;
  isSent: boolean;
  isIframe: boolean;
  isLastMessage: boolean;
};

function IntegrationButton(props: Props) {
  const {
    botInfo,
    integration,
    onIntegrationClick,
    config,
    isSent,
    isIframe,
    isLastMessage,
  } = props;
  if (!integration.name) {
    return null;
  }
  return (
    <div className="flex gap-2">
      <MessageAvatar
        isSent={isSent}
        isIframe={isIframe}
        botAvatar={botInfo.bot_info_config.chatbot_avatar}
        isLastMessage={isLastMessage}
      />
      <div className="inline-flex w-full flex-col items-start justify-start gap-3.5 rounded-xl border border-solid border-gray-200 p-4">
        {![IntegrationType.ZENDESK_LIVE_AGENT_HANDOFF].includes(
          integration.type,
        ) && (
          <div className="inline-flex items-center justify-start gap-2 self-stretch">
            <img className="h-6 w-6" src={integration.icon} />

            <span className="text-sm font-bold text-gray-900">
              {integration.title}
            </span>
          </div>
        )}

        <button
          onClick={() => {
            try {
              integration.run(onIntegrationClick, config, botInfo.id);
            } catch (err) {
              // eslint-disable-next-line no-console
              console.log(err);
            }
          }}
          style={{
            borderRadius: "10px",
            padding: "8px",
            width: "100%",
            border: `1px solid var(--whiteOrChatBotColor)`,
            cursor: "pointer",
            color: "var(--invertedColor)",
            backgroundColor: "var(--chatBotColor)",
          }}
        >
          {integration.name}
        </button>
      </div>
    </div>
  );
}

export default IntegrationButton;
